import { render, staticRenderFns } from "./ShareInfo.vue?vue&type=template&id=328d357b&scoped=true&"
import script from "./ShareInfo.vue?vue&type=script&lang=js&"
export * from "./ShareInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShareInfo.vue?vue&type=style&index=0&id=328d357b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328d357b",
  null
  
)

export default component.exports